import React from "react";
import { Box, Typography } from "@mui/material";

const IntegrationsComponent = () => {
  return (
    <Box
      className="py-12 lg:py-28"
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Left to Right Icons */}
      <Box
        className="slider-left-right"
        sx={{
          position: "absolute",
          top: { xs: "10%", md: "20%" },
          left: 0,
          right: 0,
        }}
      >
        <Box className="slide-track-left-right component">
          {["ds.jpg", "ml.jpg", "ma.webp", "ai.avif", "cs1.jpg", "cloud.jpg", "nw com-1.png", "ino.avif", "edu.jpg", "vr.jpg", "iot.jpg", "bs.avif"].map((src, idx) => (
            <Box
              key={idx}
              component="img"
              src={src}
              alt={`Integration ${idx + 1}`}
              sx={{
                width: { xs: "40px", sm: "60px", md: "80px" },
                height: { xs: "40px", sm: "60px", md: "80px" },
                margin: { xs: "4px", sm: "8px", md: "12px" },
                  borderRadius:"10px"
              }}
            />
          ))}
        </Box>
      </Box>

      {/* Right to Left Icons */}
      <Box
        className="slider-right-left"
        sx={{
          position: "absolute",
          top: { xs: "40%", md: "60%" },
          left: 0,
          right: 0,
        }}
      >
        <Box className="slide-track-right-left component">
          {["nw com-1.png", "ino.avif", "edu.jpg", "vr.jpg", "iot.jpg", "bs.avif", "ds.jpg", "ml.jpg", "ma.webp", "ai.avif", "cs1.jpg", "cloud.jpg"].map((src, idx) => (
            <Box
              key={idx}
              component="img"
              src={src}
              alt={`Integration ${idx + 13}`}
              sx={{
                width: { xs: "40px", sm: "60px", md: "80px" },
                height: { xs: "40px", sm: "60px", md: "80px" },
                margin: { xs: "4px", sm: "8px", md: "12px" },
                borderRadius:"10px"
              }}
            />
          ))}
        </Box>
      </Box>

      {/* 100+ Integrations Circular Text in the center */}
      <Box
        sx={{
          position: "relative",
          zIndex: 10,
          textAlign: "center",
          borderRadius: "50%",
          backgroundColor: "rgba(255, 255, 255,1)",
          width: { xs: "100px", sm: "150px",  },
          height: { xs: "100px", sm: "150px", },
          padding: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          backdropFilter: "blur(20px)",
        }}
        className="component"
      >
        <Typography
          sx={{
            fontSize: { xs: "16px", sm: "22px", md: "25px" },
            color: "#212D37",
            fontWeight: "bold",
          }}
          className="component"
        >
          100+ Tools
        </Typography>
      </Box>

      {/* Outer Circle with 3D Animation */}
      <Box
        className="outer-circle-3d component"
        sx={{
          position: "absolute",
          zIndex: 9,
          borderRadius: "50%",
          border: "5px solid rgba(255, 162, 49, 1)",
          width: { xs: "130px", sm: "250px",  }, // Width for mobile, tablet, and desktop
          height: { xs: "130px", sm: "250px",  }, // Height for mobile, tablet, and desktop
          top: { xs: "17%", sm: "calc(50% - 125px)" }, // Top: 17% on mobile, centered on larger screens
          left: { xs: "33%", sm: "calc(50% - 125px)" }, // Left: 33% on mobile, centered on larger screens
          transform: { sm: "translate(-50%, -50%)" }, // Translate only on larger screens
        }}
      />

      {/* Custom 3D CSS for animation */}
      <style>{`
        @keyframes rotateCircle {
          0% {
            transform: rotate3d(1, 1, 0, 0deg);
          }
          100% {
            transform: rotate3d(1, 1, 0, 360deg);
          }
        }

        @keyframes scaleEffect {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        .outer-circle-3d {
          animation: rotateCircle 10s infinite linear, scaleEffect 5s infinite ease-in-out;
        }
      `}</style>
    </Box>
  );
};

export default IntegrationsComponent;
